import { get } from '@/utils/apiBase.js';

// 获取app渠道应用下载链接
const getAppDownloadUrl = (option, headers) => {
  return get('/apis/channelput/get_app_download_url', option, headers);
};

export default {
    getAppDownloadUrl
}